import React from "react";
import get from "lodash/get";
import ReactQuill, { Quill } from "react-quill";
import { Badge, Form, Icon, Input, Popover, Select } from "antd";
import placeholderImage from "../../../assets/img/image_placeholder.jpg";
import { uploadNewsletterImage } from "../../../api/requests";
import map from "lodash/map";

var Image = Quill.import("formats/image");
Image.className = "quill_image";
Quill.register(Image, true);

const { Option } = Select;

export default class WYSIWYGEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      htmlVisible: false,
      isAddButtonVisible: false,
      isAddVariableVisible: false,
      position: 0,
      btnText: "btn_text",
      btnHref: "btn_href",
      btnClass: "default",
    };
  }

  addVariable = (variable, noWrap) => {
    noWrap = noWrap || false;
    let variableContent = "";
    if (noWrap) {
      variableContent = ` ${variable} `;
    } else {
      variableContent = ` {{${variable}}} `;
    }

    const quillRef = this.props.quillRef.current.getEditor();

    quillRef.insertText(this.state.position, variableContent);
  };

  imageHandler = () => {
    const input = document.createElement("input");
    this.props.onChanged();

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      const formData = new FormData();

      formData.append("document_file", file);

      // Save current cursor state
      const range = this.props.quillRef.current.editor.getSelection(true);

      // Insert temporary loading placeholder image
      this.props.quillRef.current.editor.insertEmbed(
        range.index,
        "image",
        placeholderImage
      );

      // Move cursor to right side of image (easier to continue typing)
      this.props.quillRef.current.editor.setSelection(range.index + 1);

      const {
        data: { url },
      } = await uploadNewsletterImage(formData);

      // Remove placeholder image
      this.props.quillRef.current.editor.deleteText(range.index, 1);

      // Insert uploaded image
      // this.props.quillRef.current.editor.insertEmbed(range.index, 'image', res.body.image);
      this.props.quillRef.current.editor.insertEmbed(range.index, "image", url);
    };
  };

  colorHandler = (id, toolbarClass, type, margin) => {
    let picker = document.getElementById(id);
    const pickerButton = document.getElementsByClassName(toolbarClass)[0];
    if (!picker) {
      picker = document.createElement("input");
      picker.id = id;
      picker.type = "color";
      // picker.style.display = 'none';
      picker.style.position = "absolute";
      picker.style.width = "1rem";
      picker.style.marginLeft = margin;
      picker.style.opacity = 0;
      picker.value = "#FF0000";
      pickerButton.parentElement.appendChild(picker);

      picker.addEventListener(
        "change",
        (e) => {
          this.props.quillRef.current.editor.format(type, picker.value);
        },
        false
      );
    }
    setTimeout(() => {
      picker.click();
    });
  };

  quillModules = {
    toolbar: {
      container: [
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["color", "background"],
        ["link", "image"],
        ["clean"],
        [{ align: [] }],
      ],
      handlers: {
        image: this.imageHandler,
        color: () =>
          this.colorHandler("color-picker", "ql-color", "color", "-3rem"),
        background: () =>
          this.colorHandler(
            "background-picker",
            "ql-background",
            "background",
            "-1.5rem"
          ),
      },
    },
  };

  render() {
    const {
      isEditable,
      getFieldDecorator,
      fieldName,
      quillRef,
      setPosition,
      onChanged,
      required,
    } = this.props;

    return (
      <React.Fragment>
        <div style={{ display: "flex", justifyContent: "flex-end", margin: '-20px 0 6px' }}>
          <Popover
            trigger={"click"}
            placement="bottom"
            visible={this.state.isAddButtonVisible}
            onVisibleChange={(visible) => {
              this.setState({ isAddButtonVisible: visible });
            }}
            content={
              <div>
                <div>
                  <div style={{ marginBottom: "5px" }}>
                    <div
                      style={{
                        color: "#707070",
                        maxWidth: "767px",
                        padding: "2px 5px",
                        display: "inline-block",
                      }}
                    >
                      <i>
                        {this.props.i18n.t(
                          "NamespaceEmailTemplates:For best results place the button on a separate line."
                        )}
                      </i>
                    </div>
                  </div>
                  <div style={{ marginBottom: "5px" }}>
                    <Input
                      style={{ width: "100%", maxWidth: "470px" }}
                      value={this.state.btnText}
                      onChange={(e) => {
                        this.setState({ btnText: e.target.value });
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "5px" }}>
                    <Input
                      style={{ width: "100%", maxWidth: "470px" }}
                      value={this.state.btnHref}
                      onChange={(e) => {
                        this.setState({ btnHref: e.target.value });
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "5px" }}>
                    <Select
                      style={{ width: "100%", maxWidth: "470px" }}
                      onChange={(value) => {
                        this.setState({ btnClass: value });
                      }}
                      value={this.state.btnClass}
                    >
                      {[
                        "default",
                        "primary",
                        "dashed",
                        "link",
                        "warning",
                        "danger",
                      ].map((item) => (
                        <Option value={item} key={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div style={{ marginBottom: "5px" }}>
                    <div
                      style={{
                        color: "#707070",
                        maxWidth: "767px",
                        background: "#eee",
                        padding: "2px 5px",
                        display: "inline-block",
                      }}
                    >{`<% button text="${this.state.btnText}" href="${this.state.btnHref}" class="${this.state.btnClass}" %>`}</div>
                  </div>

                  <Badge
                    count={`Add button`}
                    style={{
                      backgroundColor: "#2968AE",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.addVariable(
                        `<% button text="${this.state.btnText}" href="${this.state.btnHref}" class="${this.state.btnClass}" %>`,
                        true
                      );

                      this.setState({
                        isAddButtonVisible: false,
                      });
                    }}
                  />
                </div>
              </div>
            }
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              Add button shortcut <Icon type="down" />
            </a>
          </Popover>

          &nbsp;&nbsp;
          <Popover
            trigger={"click"}
            placement="bottom"
            visible={this.state.isAddVariableVisible}
            onVisibleChange={(visible) => {
              this.setState({ isAddVariableVisible: visible });
            }}
            content={
              <div style={{ maxWidth: '380px'}}>
                <div>
                  <b>Variables:</b>
                </div>
                {map(this.props.available_variables, (variable, i) => (
                  <span key={i}>
                    <Badge
                      key={variable}
                      count={variable}
                      style={{ backgroundColor: "#2968AE", cursor: "pointer" }}
                      onClick={() => {
                        this.addVariable(variable);
                        this.setState({ isAddVariableVisible: false })
                      }}
                    />
                    &nbsp;
                  </span>
                ))}
              </div>
            }
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              Add variable <Icon type="down" />
            </a>
          </Popover>
        </div>

        <Form.Item>
          {getFieldDecorator(fieldName, {
            rules: [{ required, message: this.props.i18n.t("Required") }],
            initialValue: get(this.props, fieldName, ""),
          })(
            <ReactQuill
              ref={quillRef}
              disabled={!isEditable}
              theme="snow"
              onBlur={(range, source, editor) => {
                let position = range ? range.index : 0;
                setPosition(position, fieldName);
                this.setState({ position });

                // this.setState({html: editor.getHTML(), position});
              }}
              onKeyUp={() => {
                onChanged();
              }}
              modules={this.quillModules}
            />
          )}
        </Form.Item>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/EmailTemplates/EmailTemplatesForm/WYSIWYGEditor.js